<script lang="ts" setup>
	import { textValidator } from "~/utils/validators";

	const props = withDefaults(
		defineProps<{
			value?: string;
			placeholder?: string;
		}>(),
		{
			value: "",
			placeholder: "",
		}
	);

	const emit = defineEmits<{
		(e: "update:value", value: string): void;
		(e: "change", value: string): void;
		(e: "focusin"): void;
		(e: "focusout"): void;
		(e: "enterpressed"): void;
	}>();

	const hasFocus = ref<boolean>(false);

	const value = computed({
		get() {
			return props.value;
		},
		set(value: string) {
			emit("update:value", value);
		},
	});

	function focusIn() {
		hasFocus.value = true;
		emit("focusin");
	}

	function focusOut() {
		hasFocus.value = false;
		emit("focusout");
	}

	//

	const hasContent = computed(() => {
		return value.value.trim().length > 0;
	});

	//

	const isValid = computed(() => {
		const trimmed = value.value.trim();

		return textValidator(trimmed);
	});
</script>

<template>
	<div class="search-input" :class="[{ 'has-focus': hasFocus }, { 'has-content': hasContent }, { valid: isValid }]">
		<svg class="icon" width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12.0492 14.1349C10.7874 15.099 9.21056 15.6716 7.5 15.6716C3.35786 15.6716 0 12.3137 0 8.17161C0 4.02947 3.35786 0.671608 7.5 0.671608C11.6421 0.671608 15 4.02947 15 8.17161C15 9.88212 14.4274 11.4589 13.4634 12.7207L18.364 17.6213C18.7545 18.0118 18.7545 18.645 18.364 19.0355C17.9735 19.426 17.3403 19.426 16.9498 19.0355L12.0492 14.1349ZM13 8.17161C13 11.2092 10.5376 13.6716 7.5 13.6716C4.46243 13.6716 2 11.2092 2 8.17161C2 5.13404 4.46243 2.67161 7.5 2.67161C10.5376 2.67161 13 5.13404 13 8.17161Z"
				fill="black"
			/>
		</svg>

		<input-text
			type="text"
			@enterpressed="() => $emit('enterpressed')"
			:placeholder="placeholder"
			v-model:value="value"
			@change="() => $emit('change', value)"
			@focusin="focusIn"
			@focusout="focusOut"
		/>
	</div>
</template>

<style scoped lang="scss">
	.search-input {
		position: relative;
		display: flex;
		transition: all 0.1s ease-out, height 0s;
		width: 100%;
		@extend .gpu;
		pointer-events: all;
		flex-direction: column !important;
		text-align: left;
		width: 100%;
		margin-bottom: 25px;

		.icon {
			position: absolute;
			top: 50%;
			left: 20px;
			transform: translateY(-50%);
			pointer-events: none;
			z-index: 1;
		}

		input {
			font-size: 18px;
			background: white;
			border-radius: 22px;
			outline: none;
			cursor: text !important;
			@include h4(false);
			line-height: 44px;
			width: 100%;
			box-sizing: border-box;
			transition: inherit;
			pointer-events: all;
			padding-left: 45px;
			padding-right: 15px;
			border: 1px solid $grey;
		}

		&.has-content,
		&.has-focus {
			input {
				border-color: $black;
			}
		}

		&.valid {
		}

		&.has-focus {
		}
	}
</style>
